export default class AddressEditor
{	
	constructor(divId)
	{
		this.divId = divId;
		this.country = null;
		this.state = null;
		this.stateCode = null;
		this.zipCode = null;
		this.district = null;
		this.city = null;
		this.addressLine1 = null;
		this.addressLine2 = null;
		this.phone = null;
		this.phoneCountryCode = null;
		
		this.addressEditorConfig = null;
		this.callAPI = false;
		this.countryConfiguration = null;

		this.stateSelect = null;
		this.populationSelect = null;
		
		addressForms.push(this);
		this.initAddressValidation();
	}

	initAddressValidation()
	{
		if(validationInitialized)
		{
			return;
		}
		
		$('#formAddressEdition').on("formvalid.zf.abide", function (ev, frm) {
			currentAddressEditor.validate();
		}).on("submit", function (ev) {
			ev.preventDefault();
		});
		
		validationInitialized = true;
	}
	
	paintAddressForm(addressEditorConfig)
	{
		let addressForm = document.getElementById(this.divId);
		
		this.addressEditorConfig = addressEditorConfig;
		
		if(addressForm == null)
		{
			return;
		}
		
		addressForm.style.display = "block";
				
		let html = '';
		
		if(addressEditorConfig.address.isRequested)
		{
			html += this.paintAddress(addressEditorConfig);
		}
		else 
		{
			if(addressEditorConfig.phone.isRequested)
			{
				html += this.paintPhone();
			}			
			
			if(addressEditorConfig.cp.isRequested)
			{
				html += this.paintCp();
			}
		}
		
		if((addressEditorConfig.phone.isMandatory && !addressEditorConfig.address.isMandatory) || addressEditorConfig.phone.phoneShowingDiv != null )
		{
			let phoneVisorHtml = this.paintPhone();
			document.getElementById(addressEditorConfig.phone.phoneShowingDiv).innerHTML = phoneVisorHtml;
		}
		
		addressForm.innerHTML = html;
		
		this.checkPhoneInputLocation(addressEditorConfig);
		this.requireMandatoryFields(addressEditorConfig);
		
		this.selectCountryWithFlags();
		
		const populationSelector = document.getElementById('populationSelect');

		if(populationSelector == null)
		{
			this.populationSelect =  new Choices('#populationSelect', {
				removeItemButton: true,
				duplicateItemsAllowed: false,
				shouldSort: true,
				placeholder: true,
				placeholderValue: '--',
				noResultsText: polyglot.t('choices.No_results_found'),
   				noChoicesText: polyglot.t('choices.No_choices_to_choose_from'),
   				itemSelectText: '',
    			uniqueItemText: polyglot.t('choices.Only_unique_values_can_be_added')
			});
			
			this.populationSelect.setValue([]);
		}

		$(".form-error-address").hide();
	}
	
	selectCountryWithFlags()
	{
		if(selectCountry !== null)
		{
			return;
		}

		const countrySelect = document.getElementById('country');
		
		if (countrySelect != null)
		{			
			selectCountry = new Choices('#country', {
			    removeItemButton: true,
			    duplicateItemsAllowed: false,
    			noResultsText: polyglot.t('choices.No_results_found'),
   				noChoicesText: polyglot.t('choices.No_choices_to_choose_from'),
   				itemSelectText: '',
    			uniqueItemText: polyglot.t('choices.Only_unique_values_can_be_added'),
    			callbackOnCreateTemplates: function(strToEl) 
    			{
			       
			        return {
						item:(classNames, data) => 
			            {
							let item = strToEl(`
					          <div class="${classNames.item} ${
					          data.highlighted
					            ? classNames.highlightedState
					            : classNames.itemSelectable
					        } ${
					          data.placeholder ? classNames.placeholder : ''
					        }" data-item data-id="${data.id}" data-value="${data.value}" ${
					          data.active ? 'aria-selected="true"' : ''
					        } ${data.disabled ? 'aria-disabled="true"' : ''}>
					            <i class="${data.value.toLowerCase()} flag"></i> ${data.label}
					          </div>
					        `);
					        
					        return item;
						},
			            choice: (classNames, data) => 
			            {
							let option = strToEl(`
							<div class="${classNames.item} ${classNames.itemChoice} ${
					          data.disabled ? classNames.itemDisabled : classNames.itemSelectable
					        }" data-select-text="${this.config.itemSelectText}" data-choice ${
					          data.disabled
					            ? 'data-choice-disabled aria-disabled="true"'
					            : 'data-choice-selectable'
					        } data-id="${data.id}" data-value="${data.value}" ${
					          data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
					        }>
					            <i class="${data.value.toLowerCase()} flag"></i> ${data.label}
					          </div>
				              `);
	
			               return option;
			            }
			        };
			    },
		    });
		    
		    addAutotestChoicesIds('country');

			this.configureSelect(selectCountry);
		}

	}
	
	configureSelect(selectSelected)
	{
		selectSelected.placeholderValue = '--';
		selectSelected.setValue([]);
	}
	
	paintAddress(addressEditorConfig)
	{
		let html = '<div class="row">'
		html +=	'<div class="large-8 columns">'
		html +=	'<label>' +
		polyglot.t("Address");
		
		if(addressEditorConfig.phone.isRequested && (addressEditorConfig.phone.phoneShowingDiv == null))
		{
			html += "/" + polyglot.t("Telephone");
		}
		 
		html += '<textarea id="' + this.divId + '_input" name="address" maxlength="100" rows="2" placeholder=' + polyglot.t("Address")
		 + ' style="min-height:2.5rem;min-width:25rem" onfocus="openSelectedAddressModal(\'' + this.divId + '\')" required />'
		html +=	'</textarea>';
		html +=	'<span class="form-error-address">' + polyglot.t("error.address") + '</span>'
		html +=	'</label></div>'
		html += '</div>';
				
		return html;
	}
	
	paintPhone()
	{
		let html = '<div class="row">'
			+ '<div class="large-4 medium-4 columns">'
				+ '<label for="phone">' + polyglot.t("Telephone")

            if (this.phone != null && this.phone.length > 0)
            {
                html += '<input class="input" name="phone" id="phone" type="tel" pattern="^(\\+\\d{1,3})?([\\(]\\d{0,15}[\\)])?([0-9\\-\\ ]{0,25})$"'
                      + ' value="' + this.phone + '" readonly onclick="openSelectedAddressModal(\'' + this.divId + '\')">';
            }
            else
            {
                html += '<input class="input" name="phone" id="phone" type="tel" pattern="^(\\+\\d{1,3})?([\\(]\\d{0,15}[\\)])?([0-9\\-\\ ]{0,25})$"'
                      + ' placeholder="' + polyglot.t("Telephone") + '" readonly onclick="openSelectedAddressModal(\'' + this.divId + '\')">';
            }

		html += '<span class="form-error">'
	        + polyglot.t("error.phone")
	    + '</span>'
		
		+ '</div>';
		
		return html;
	}  
	
	paintCp()
	{
		let html = '<div class="row">'
			+ '<div class="large-12 medium-12 columns">'
				+ '<label for="cp">' + polyglot.t("global.zip_code")
				
						if(this.zipCode != null)
						{
							 html += '<input class="input" value="' + this.zipCode + '" name="cp" id="cp" type="text" placeholder="' + polyglot.t("global.zip_code") + '">'
						}
						else
						{
							 html += '<input class="input" name="cp" id="cp" type="text" placeholder="' + polyglot.t("global.zip_code") + '">'
						}
		 html += '<small class="error">' + polyglot.t("error.zipCode") + '</small>'
				+ '</label>'
			+ '</div>'
		+ '</div>';
		
		return html;
	}
	
	checkPhoneInputLocation(addressEditorConfig)
	{
		if(!addressEditorConfig.phone.isRequested)
		{
			if(addressEditorConfig.phone.phoneShowingDiv != null)
			{
				$('#' + addressEditorConfig.phone.phoneShowingDiv).hide();
			}			
		}
		
		if(!addressEditorConfig.address.isMandatory && addressEditorConfig.phone.isMandatory)
		{
			document.querySelector('#formAddressEdition #phone').parentNode.remove();
		}
	}
	
	requireMandatoryFields(addressEditorConfig)
	{		
		$('#' + this.divId + "_input").attr("required", addressEditorConfig.address.isMandatory);
		
		if(currentAddressEditor != null && currentAddressEditor.countryConfiguration != null && !currentAddressEditor.countryConfiguration.fields.locality.optional && !currentAddressEditor.countryConfiguration.fields.locality.hidden)
		{
			$('#city').attr("required", addressEditorConfig.address.isMandatory);
		}
		
		if(currentAddressEditor != null && currentAddressEditor.countryConfiguration != null && !currentAddressEditor.countryConfiguration.fields.postal_code.optional  && !currentAddressEditor.countryConfiguration.fields.postal_code.hidden)
		{
			$('#pc').attr("required", addressEditorConfig.address.isMandatory);
		}
		
		if(currentAddressEditor != null && currentAddressEditor.countryConfiguration != null && !currentAddressEditor.countryConfiguration.fields.address_1.optional   && !currentAddressEditor.countryConfiguration.fields.address_1.hidden)
		{
			$('#addressLine1').attr("required", addressEditorConfig.address.isMandatory);
		}
					
		$('#phone').attr("required", addressEditorConfig.phone.isMandatory);		
	} 
	
	openSelectedAddressModal()
	{	
		showModal('#vAddressEditor');
		document.getElementById('saveAddressFooter').style.display = 'none';
		document.getElementById('validateAddressFooter').style.display = 'block';	
		
		document.getElementById('populationInput').innerHTML = '<label>' + polyglot.t("Province") + '</label><select id="populationSelect" name="province" placeholder="' + polyglot.t("Province") + '" disabled /><option>--</option></select>';			
		document.getElementById('stateInput').innerHTML = '<label>' + polyglot.t("State") + '</label><select id="stateSelect" name="state" placeholder="' + polyglot.t("State") + '" disabled /><option>--</option></select>';
						
		if(this.country === undefined || this.country === null || this.country.length === 0)
		{			
			if(typeof serverProgrammedCountry !== 'undefined' && serverProgrammedCountry != null && serverProgrammedCountry.length > 0)
			{
				selectCountry.setChoiceByValue(serverProgrammedCountry);
				countrySelected(serverProgrammedCountry);
				this.changeAllInputsDisabledProperty(false);	
			}
			else if(typeof serverLanguage !== 'undefined' && serverLanguage != null && serverLanguage.length > 0)
			{
				this.getCountryFromServerLanguage();
				this.changeAllInputsDisabledProperty(false);	
			}
			else
			{
				countrySelected(selectCountry.getValue().value);	
			}	
			
		}
		else
		{
			this.changeAllInputsDisabledProperty(false);
			selectCountry.setChoiceByValue(this.country);
			countrySelected(this.country);
		}
		
		if($("#country").val() == 'US' || $("#country").val() == 'MX' || $("#country").val() == 'CA')
		{
			const stateSelector = document.getElementById('stateSelect');
			
			if(this.stateSelect != null)
			{
				this.stateSelect.destroy();
			}

			if(stateSelector != null)
			{	
				this.stateSelect = new Choices('#stateSelect', {
					removeItemButton: true,
					duplicateItemsAllowed: false,
					placeholder: true,
					placeholderValue: '--',
					noResultsText: polyglot.t('choices.No_results_found'),
   					noChoicesText: polyglot.t('choices.No_choices_to_choose_from'),
	   				itemSelectText: '',
    				uniqueItemText: polyglot.t('choices.Only_unique_values_can_be_added')
				});
				
				addAutotestChoicesIds('stateSelect');
				
				this.stateSelect.setChoiceByValue(this.stateCode);
			}
		}
		else
		{
			const populationSelector = document.getElementById('populationSelect');
			
			if(this.populationSelect != null)
			{
				this.populationSelect.destroy();
			}

			if(populationSelector != null)
			{	
				this.populationSelect = new Choices('#populationSelect', {
					removeItemButton: true,
					duplicateItemsAllowed: false,
					placeholder: true,
					placeholderValue: '--',
					noResultsText: polyglot.t('choices.No_results_found'),
   					noChoicesText: polyglot.t('choices.No_choices_to_choose_from'),   				
   					itemSelectText: '',
    				uniqueItemText: polyglot.t('choices.Only_unique_values_can_be_added')
				});
				
				addAutotestChoicesIds('populationSelect');
				
				this.populationSelect.setChoiceByValue(this.stateCode);
			}
		}
		
		$("#formAddressEdition input[name='district']").val(this.district);
		$("#formAddressEdition input[name='city']").val(this.city);
		$("#formAddressEdition input[name='pc']").val(this.zipCode);
		$("#formAddressEdition input[name='addressLine1']").val(this.addressLine1);
		$("#formAddressEdition input[name='phone']").val(this.phone);
		$("#formAddressEdition input[name='addressLine2']").val(this.addressLine2);	
		
		this.requireMandatoryFields(this.addressEditorConfig);
	}
	
	getCountryFromServerLanguage()
	{
		let country = null;
		
		for(let i = 0; i < COUNTRIES.length; i++)
		{
			country = COUNTRIES[i];
			
			if(country.languages != null && country.languages.length > 0)
			{
				let countryLanguages = country.languages.split(",");
				  
				if(countryLanguages != null && countryLanguages.length > 0 && countryLanguages.includes(serverLanguage.replace("_", "-")))
				{
					selectCountry.setValue(country.iso);
					break;
				}
			}
		}
	}
	
	buildAddressText(isPalceholder)
	{
		let addressText = '';
		let addressValue = null;
		
		if(this.countryConfiguration == null)
		{
			if(this.country == null)
			{
				this.countryConfiguration = getCountry('ES');
			}
			else
			{
				this.countryConfiguration = getCountry(this.country);
			}			
		}
		
		addressValue = this.checkAddressValue(this.addressLine1, addressText)
		if(this.countryConfiguration != null && !this.countryConfiguration.fields.address_1.hidden && !addressValue && !isPalceholder && this.countryConfiguration.fields.validate_address)
		{
			return '';
		}
		addressText += addressValue;
		
		addressText += this.checkAddressValue(this.addressLine2, addressText);
		
		addressValue = this.checkAddressValue(this.city, addressText)
		if(this.countryConfiguration != null && !this.countryConfiguration.fields.locality.hidden && !addressValue && !isPalceholder && this.countryConfiguration.fields.validate_address)
		{
			return '';
		}
		addressText += addressValue;
		
		addressValue = this.checkAddressValue(this.state, addressText)
		if(this.countryConfiguration != null && !this.countryConfiguration.fields.province.hidden && !addressValue && !isPalceholder && this.countryConfiguration.fields.validate_address)
		{
			return '';
		}
		addressText += addressValue;
		
		addressValue = this.checkAddressValue(this.country, addressText)
		if(!addressValue && !isPalceholder && this.countryConfiguration != null && this.countryConfiguration.fields.validate_address)
		{
			return '';
		}
		addressText += addressValue;
		
		addressValue = this.checkAddressValue(this.zipCode, addressText)
		if(this.countryConfiguration != null && !this.countryConfiguration.fields.postal_code.hidden && !addressValue && !isPalceholder && this.countryConfiguration.fields.validate_address)
		{
			return '';
		}
		else if(this.countryConfiguration != null && this.countryConfiguration.fields != null && this.countryConfiguration.fields.postal_code != null && !this.countryConfiguration.fields.postal_code.hidden && addressValue && !isPalceholder)
		{
			addressText += addressValue;
		}	
		
		return addressText;
	}

	checkAddressValue(addressValue, addressText)
	{
		let text ='';
		if(addressValue != undefined && addressValue!= null && addressValue.length > 0)
		{
			if(addressText.length !== 0)
			{
				text += ", ";
			}
			
			text += addressValue;	
		}
		
		return text;
	}
	
	resetAddress()
	{
		this.country = null;
		this.state = null;
		this.stateCode = null;
		this.zipCode = null;
		this.city = null;
		this.district = null;
		this.addressLine1 = null;
		this.addressLine2 = null;
		this.phone = null;
		
		$("textarea[id=" + this.divId + "_input]").val(null);
	}
	
	changeAllInputsDisabledProperty(isDisabled)
	{
		$("#formAddressEdition select[name='state']").attr("disabled", isDisabled);
		$("#formAddressEdition select[name='province']").attr("disabled", isDisabled);
		$("#formAddressEdition input[name='district']").attr("disabled", isDisabled);
		
		if(currentAddressEditor.countryConfiguration != null && currentAddressEditor.countryConfiguration.fields.locality.hidden != null && !currentAddressEditor.countryConfiguration.fields.locality.hidden)
		{
			$("#formAddressEdition input[name='city']").attr("disabled", isDisabled);
		}
		
		$("#formAddressEdition input[name='pc']").attr("disabled", isDisabled);
		$("#formAddressEdition input[name='addressLine1']").attr("disabled", isDisabled);
		$("#formAddressEdition input[name='phone']").attr("disabled", isDisabled);
		$("#formAddressEdition input[name='addressLine2']").attr("disabled", isDisabled);
	}	
	
	validate()
	{
		if(selectCountry.getValue().length == 0 || $("#country").val() == 'null' || $("#country").val().length === 0)
		{
			loadNotification([polyglot.t("global.Please_select_a_country")], "error", 5000);
			return null;
		}	
			
		this.country = $("#country").val();
		
		if(this.stateSelect != null)
		{
			this.state = this.stateSelect.getValue() != null ? this.stateSelect.getValue().label : null;
		}
		else
		{
			if(COUNTRIES_WITH_STATES.includes(this.country))
			{
				this.state = $("#formAddressEdition input[name='state']").val();
			}
			else
			{
				this.state = $("#formAddressEdition input[name='province']").val();
			}	
		}
		
		if(this.addressEditorConfig.address.isMandatory && !this.countryConfiguration.fields.province.optional && (this.state == null || this.state == "--" || this.state.length == 0))
		{
			loadNotification([polyglot.t("global.Please_select_a_state_province")], "error", 5000);
			return null;
		}			
		
		this.district = $("#formAddressEdition input[name='district']").val();
		this.city = $("#formAddressEdition input[name='city']").val();
		this.zipCode = $("#formAddressEdition input[name='pc']").val();
		this.addressLine1 = $("#formAddressEdition input[name='addressLine1']").val();
		this.phone = $("#formAddressEdition input[name='phone']").val().trim().replaceAll(' ', '');
		this.addressLine2 = $("#formAddressEdition input[name='addressLine2']").val();
		
		if(this.isRequiredInputMissing())
		{
			return false;
		} 
		
		if(this.addressEditorConfig.phone.phoneShowingDiv != null)
		{
			$('#phone').val(this.phone);
		}
		
		let searchJSON = JSON.stringify(this.getSearchTerm());
		
		this.connectToGeolocationDatabase(searchJSON, geolocationUrl);
	}
	
	saveSuggestedAddress()
	{
		let address = suggestedAddresses[selectedAddressPosition];
		
		this.zipCode = address.postal_code;
		
		if(address.country_code == 'ES')
		{
			this.city = address.place_name;
			this.state = address.admin_name_2;
			this.stateCode = address.admin_code_2;
		}
		else if(address.country_code == 'MX')
		{
			this.city = address.admin_name_2;
			this.state = address.admin_name_1;
			this.stateCode = address.admin_code_1;
			this.district = address.place_name;
		}
		else
		{
			this.city = address.place_name;
			this.state = address.admin_name_1;
			this.stateCode = address.admin_code_1;
			this.district = address.admin_name_2;
		}
		
		this.phoneCountryCode = phonePrefix;
		
		if(this.phone != null && this.phoneCountryCode != null && this.phone.startsWith(this.phoneCountryCode))
		{
			this.phone = this.phone.replace(this.phoneCountryCode, "");
		}
		
		$(".form-error-address").hide();
		$("#addressForm label").removeClass('is-invalid-label');
		$("#addressForm textarea").removeClass('is-invalid-input');
		
		$("textarea[id=" + this.divId + "_input]").val(this.buildAddressText(false));
		hideModal('vAddressEditor');
	}
	
	getSearchTerm()
	{
		let searchTerm = '';
		
		searchTerm = this.addToSearchTerm(this.state, searchTerm);
		searchTerm = this.addToSearchTerm(this.city, searchTerm);
		searchTerm = this.addToSearchTerm(this.zipCode, searchTerm);
		searchTerm = this.addToSearchTerm(this.district, searchTerm);
		
		return {
			searchTerm: searchTerm,
			countryCode: this.country
		};
	}
	
	addToSearchTerm(addressData, searchTerm)
	{
		let addressFormatted = null;
		if(addressData != null && addressData.length > 0)
		{
			addressFormatted = addressData.replaceAll(" ", " & ");
			if(searchTerm.length == 0)
			{
				searchTerm += addressFormatted;
			}
			else
			{
				searchTerm += " & " + addressFormatted;
			}			
		}
		
		return searchTerm;
	}
	
	isRequiredInputMissing()
	{
		if(this.addressEditorConfig.address.isMandatory)
		{
			if(this.country === null || this.country.length === 0 ||
			(!this.countryConfiguration.fields.province.optional && !this.countryConfiguration.fields.province.hidden && (this.state == null || this.state.length == 0)) ||
			(!this.countryConfiguration.fields.postal_code.optional && !this.countryConfiguration.fields.postal_code.hidden && (this.zipCode == null || this.zipCode.length == 0)) ||
			(!this.countryConfiguration.fields.locality.optional && !this.countryConfiguration.fields.locality.hidden && (this.city == null || this.city.length == 0)) ||
			(!this.countryConfiguration.fields.address_1.optional && !this.countryConfiguration.fields.address_1.hidden && (this.addressLine1 == null || this.addressLine1.length == 0)))
			{
				return true;
			} 
		}
		
		if(this.addressEditorConfig.phone.isMandatory)
		{
			if(this.phone === null || this.phone.length === 0)
			{
				return true;
			} 
		}

		return false;
	}
	
	connectToGeolocationDatabase(addressString, url)
	{
		geolocationUrl = url;
		
		
		if(geolocationUrl == null)
		{
			BackofficeAjax.getGeolocationEndpoint((url) => this.connectToGeolocationDatabase(addressString, url));
			return;
		}
		
		url += 'validate';
		
		let req  = new XMLHttpRequest();
		req.open('POST', url, true);
		req.setRequestHeader('Content-type', 'application/json; charset=utf-8');
		
		req.addEventListener('error', function ()
		{
			currentAddressEditor.saveAddressWhenSetToNoValidate();
		});
		
		req.onload = function () 
		{			
			if((!req.responseText.startsWith('[{') && req.responseText != "[]") || setToNoValidate || (!currentAddressEditor.addressEditorConfig.address.isMandatory && !currentAddressEditor.isAddressReadyToValidate()))
			{
				currentAddressEditor.saveAddressWhenSetToNoValidate();
				return;
			}
				
			let response = JSON.parse(req.responseText);
			if (req.readyState == 4 && req.status == "200") 
			{
				if(response.length == 0 || response.name == "error")
				{
					loadNotification([polyglot.t("addressEditor.Address_not_found")], "error", 5000);
					document.getElementById('saveAddressFooter').style.display = 'block';
					document.getElementById('validateAddressFooter').style.display = 'none';
					return false;
				}
				hideModal('#vAddressEditor');
				setTimeout(function() {
					if(!currentAddressEditor.countryConfiguration.fields.validate_address)
					{	
						let cityInput = document.getElementById('city');
						
						let suggestedCities = currentAddressEditor.checkResponseOptions(response);
						
						if(currentAddressEditor.stateSelect.getValue().value == null || currentAddressEditor.stateSelect.getValue().value.length == 0 || currentAddressEditor.stateSelect.getValue().value == "--"
							|| document.getElementById('city').value == null || document.getElementById('city').value.length == 0)
						{
							currentAddressEditor.saveAddressWhenSetToNoValidate();
							return;
						}
										
						if(suggestedCities.filter(sc => sc.city == cityInput.value).length > 0)
						{
							currentAddressEditor.saveAddressWhenSetToNoValidate();
							return;
						}
						
						let suggestedCitiesDiv = document.getElementById('suggestedCities');
						
						suggestedCitiesDiv.innerHTML = currentAddressEditor.paintCitiesSuggested(suggestedCities);
						
						showModal('#vCitySuggestions');
					}
					else
					{
						showModal('#vAddressValidation');
					}					
				}, 500);
				
				currentAddressEditor.showValidationResults(response);
				document.getElementById('saveAddressFooter').style.display = 'none';
				document.getElementById('validateAddressFooter').style.display = 'block';	
			} 
			else 
			{
				alertaKO(response.data);
			}
		}
		
		req.send(JSON.stringify({country: this.country, state: this.state, city: this.city, zipCode: this.zipCode, district: this.district}));
	}
	
	checkResponseOptions(response)
	{
		let suggestedCities = [];
		let responseAddress = null;
		for(let i = 0; i < response.length; i++)
		{
			responseAddress = response[i];
			
			if(suggestedCities.filter(sc => sc.city == responseAddress.place_name).length == 0)
			{
				suggestedCities.push({ "city": responseAddress.place_name, "state": responseAddress.admin_name_1});
			}
		}
		
		return suggestedCities;
	}
	
	paintCitiesSuggested(citiesSuggested)
	{
		let html = "";
		let cityOption = null;
		suggestedCities = citiesSuggested;
		
		for(let i = 0; i < citiesSuggested.length; i++)
		{
			cityOption = citiesSuggested[i];
			
			html +='<div class="custom-checkbox space-bottom">'
				+"<input type='radio' id='" + i + "' name='citySuggestions' value='" + i + "' onclick='selectSuggestedAddress(" + i + ")'" + (i == 0 ? "checked" : "") + "/><label for='" + i + "'>" + cityOption.city + " in " + cityOption.state  + "</label>";
			+'</div>';
		}
		
		return html;
	}
	
	saveCityByPosition()
	{
		if(selectedAddressPosition != null)
		{
			currentAddressEditor.saveSuggestedCity(suggestedCities[selectedAddressPosition].city);
		}
	}	
	
	saveSuggestedCity(city)
	{
		currentAddressEditor.city = city;
		currentAddressEditor.saveAddressWhenSetToNoValidate();
	}
	
	isAddressReadyToValidate()
	{
		let isAddressValidated = currentAddressEditor.countryConfiguration.fields.validate_address;
		if(isAddressValidated && (currentAddressEditor.stateCode == null || currentAddressEditor.stateCode.length == 0 || $('#country').val().length == 0 || $('#pc').val().length == 0 ||  $('#city').val().length == 0))
		{
			return false;
		}
		
		return true;
	}
	
	saveAddressWhenSetToNoValidate()
	{
		$("textarea[id=" + currentAddressEditor.divId + "_input]").val(currentAddressEditor.buildAddressText(false));
		
		this.phoneCountryCode = phonePrefix;
		
		if(this.phone != null && this.phoneCountryCode != null && this.phone.startsWith(this.phoneCountryCode))
		{
			this.phone = this.phone.replace(this.phoneCountryCode, "");
		}
		
		if(stateCodeSelectedNotSaved != null)
		{
			currentAddressEditor.stateCode = stateCodeSelectedNotSaved;
		}
		hideModal('#vAddressEditor');
		cambiarVentanaEsperaOK();
	}
	
	showValidationResults(addresses)
	{
		let i = 0;
		let html = '';
		
		suggestedAddresses = [];
		
		for(let address of addresses)
		{
			suggestedAddresses.push(address);
			
			html += '<div class="typeTicketSelector">'
			
			if(i == 0)
			{
				html += '<input type="radio" name="addressSuggested" id="addressSuggested_' + i + '" class="" checked="checked" onclick="selectSuggestedAddress(' + i + ')"/>'
			}
			else
			{
				html += '<input type="radio" name="addressSuggested" id="addressSuggested_' + i + '" class="" onclick="selectSuggestedAddress(' + i + ')"/>'
			}
			html += '<label for="addressSuggested_' + i++ + '" class="" >';
		
			if(address.country_code == 'ES')
			{
				html += this.addressLine1 + ', '  + address.place_name + ', ' + address.admin_name_2 + ', ' + address.postal_code + ', ' + address.country_code + '</label>';
			}
			else if(address.country_code == 'MX')
			{
				html += this.addressLine1 + ', '  + address.admin_name_2 + ', ' + address.admin_name_1 + ', ' + address.place_name + ', ' + address.postal_code + ', ' + address.country_code + '</label>';
			}
			else
			{
				html += this.addressLine1 + ', '  + address.place_name + ', ' + address.admin_name_1 + ', ';
				
				if(this.countryConfiguration != null && this.countryConfiguration.fields != null && this.countryConfiguration.fields.postal_code != null && (this.countryConfiguration.fields.postal_code.hidden == null || !this.countryConfiguration.fields.postal_code.hidden))
				{
					html += address.postal_code + ', ';
				}
				
				html += address.country_code + '</label>';
			}
			
			html += '</div>';
		}
		
		this.selectSuggestedAddress(0);
		
		document.getElementById('addressesSuggested').innerHTML = html;
	}
	
	selectSuggestedAddress(position)
	{
		selectedAddressPosition = position;
	}
	
	loadStates(countrySelected, statesContainer, url)
	{	
		const countryValue = selectCountry.getValue() != null ? selectCountry.getValue().value : null;

		if(lastInputCode == countryValue || countryValue.length == 0)
		{
			return;
		}
		
		setToNoValidate = false;
		
		geolocationUrl = url;
		
		if(this.populationSelect != null)
		{
			this.populationSelect.destroy();
		}
		else if(this.stateSelect != null)
		{
			this.stateSelect.destroy();
		}
		
		if(geolocationUrl == null)
		{
			BackofficeAjax.getGeolocationEndpoint((url) => this.loadStates(countrySelected, statesContainer, url)); 
		}
		else
		{
			url += 'getStates';
			
			if(currentAddressEditor.countryConfiguration.fields.province.name != null)
			{
				document.getElementById('populationInput').innerHTML = '<label>' + polyglot.t(currentAddressEditor.countryConfiguration.fields.province.name) + '</label><select id="populationSelect" name="province" placeholder="' + polyglot.t("Province") + '" onchange="setStateCode()" /><option>--</option></select>';			
				document.getElementById('stateInput').innerHTML = '<label>' + polyglot.t(currentAddressEditor.countryConfiguration.fields.province.name) + '</label><select id="stateSelect" name="state" placeholder="' + polyglot.t("State") + '" onchange="setStateCode()" /><option>--</option></select>';
			}
			else
			{
				document.getElementById('populationInput').innerHTML = '<label>' + polyglot.t("Province") + '</label><select id="populationSelect" name="province" placeholder="' + polyglot.t("Province") + '" onchange="setStateCode()" /><option>--</option></select>';			
				document.getElementById('stateInput').innerHTML = '<label>' + polyglot.t("State") + '</label><select id="stateSelect" name="state" placeholder="' + polyglot.t("State") + '" onchange="setStateCode()" /><option>--</option></select>';
			}
		
			let reqBody = {
				countryCode: countrySelected
			}
			
			let req  = new XMLHttpRequest();
			req.open('POST', url, true);
			req.setRequestHeader('Content-type', 'application/json; charset=utf-8');
			
			req.addEventListener('error', function ()
			{
				currentAddressEditor.changeStateSelectToInputAndSetToNoValidate();
			});
			
			req.onload = function () 
			{
				if(!req.responseText.startsWith('[{'))
				{
					currentAddressEditor.changeStateSelectToInputAndSetToNoValidate();
					return;
				}	

				let response = JSON.parse(req.responseText);
				
				if (req.readyState == 4 && req.status == "200") 
				{
					currentAddressEditor.setZipcodePattern(response, countrySelected);			
					currentAddressEditor.loadStatesOnStateSelect(statesContainer, countrySelected, response);
					currentAddressEditor.checkCountryHasValidation(response);	
				} 
				else 
				{
					alertaKO(response.data);
				}
			}
			
			req.send(JSON.stringify(reqBody));
		}
	}
	
	changeStateSelectToInputAndSetToNoValidate()
	{
		this.stateSelect = null;
		
		if(COUNTRIES_WITH_STATES.includes(countrySelected))
		{
			document.getElementById('stateInput').innerHTML = '<label>' + polyglot.t("State") + '</label><input type="text" id="stateSelect" name="state" placeholder="' + polyglot.t("State") + '" />';
			$("#stateSelect").val(currentAddressEditor.state);
		}
		else
		{
			document.getElementById('populationInput').innerHTML = '<label>' + polyglot.t("Province") + '</label><input type="text" id="populationSelect" name="province" placeholder="' + polyglot.t("Province") + '"/>';
			$("#populationSelect").val(currentAddressEditor.state);
		}
		
		$('#pc').attr('pattern', 'alpha_numeric');
		
		setToNoValidate = true;
	}
	
	setZipcodePattern(response, countrySelected)
	{
		if(response.length == 0)
		{
			return;
		}
		
		let zipcodePattern = response[0].postal_code;
		
		if(currentAddressEditor.countryConfiguration.fields.postal_code.hidden)
		{
			zipcodePattern = 'alpha_numeric';
		}
		
		$('#pc').attr('pattern', zipcodePattern.replace('d','[0-9]'));		
	}
	
	loadStatesOnStateSelect(selector, countrySelected, statesList)
	{
		let statesOptions = [];
		
		if(this.stateSelect != null)
		{
			this.stateSelect.destroy();
		}

		this.stateSelect = new Choices(selector, {
			removeItemButton: true,
			duplicateItemsAllowed: false,
			placeholder: true,
			placeholderValue: '--',
			noResultsText: polyglot.t('choices.No_results_found'),
   			noChoicesText: polyglot.t('choices.No_choices_to_choose_from'),
			itemSelectText: '',
			uniqueItemText: polyglot.t('choices.Only_unique_values_can_be_added')
		});
		
		statesList.forEach(c => {
			let stateOption = {
				value : c.admin_code_1,
				text : c.admin_name_1
			}
			statesOptions.push(stateOption);
		})
		
		this.stateSelect.setChoices(statesOptions, 'value', 'text', true);

		$(selector).empty();
		$.each(statesOptions, function(i, option) {
			$(selector).append($("<option>", option));
		});
		
		addAutotestChoicesIds('populationSelect');
		addAutotestChoicesIds('stateSelect');

		this.configureSelect(this.stateSelect);
		
		if(this.stateCode != null)
		{
			this.stateSelect.setChoiceByValue(currentAddressEditor.stateCode);
		}
		
		if(currentAddressEditor.addressEditorConfig.address.isMandatory)
		{
			$(selector).attr('required', true);
		}
	}
	
	checkCountryHasValidation(response)
	{
		setToNoValidate = !response[0].has_validation;
	}
	
	fillDataOnZipcodeSelected(url)
	{
		geolocationUrl = url;
		
		if(geolocationUrl == null && this.callAPI == false)
		{
			this.callAPI = true;
			BackofficeAjax.getGeolocationEndpoint((url) => this.fillDataOnZipcodeSelected(url));
			return;
		}
		else if(geolocationUrl == null && this.callAPI == true) 
		{
			return;
		}
		
		url += 'getDataFromZipcode';
		
		let reqBody = {
			zipCode: $('#pc').val(),
			countryCode: $('#country').val()
		}
		
		let req  = new XMLHttpRequest();
		req.open('POST', url, true);
		req.setRequestHeader('Content-type', 'application/json; charset=utf-8');
		
		req.onload = function () 
		{
			let response = JSON.parse(req.responseText);
			if (req.readyState == 4 && req.status == "200") 
			{	
				if(response.length == 0)
				{
					loadNotification([polyglot.t("addressEditor.Invalid_zipcode")], "error", 5000);			
					$('#pc').val('');
					return null;
				}
				
				currentAddressEditor.fillAddressInputsFromZipCode(response);	
			} 
			else 
			{
				alertaKO(response.data);
			}
		}
		
		req.send(JSON.stringify(reqBody));
	}
	
	fillAddressInputsFromZipCode(response)
	{
		if($('#country').val() == 'ES')
		{
			if(this.populationSelect != null)
			{
				this.populationSelect.setValue(response[0].admin_name_2, true);
			}
			else
			{
				this.stateSelect.setValue(response[0].admin_name_2, true);
			}
			
			$('#city').val(response[0].place_name);
			
			return;	
		}
		else
		{
			if(this.populationSelect != null)
			{
				this.populationSelect.setValue(response[0].admin_name_1, true);
			}
			else
			{
				this.stateSelect.setValue(response[0].admin_name_1, true);
			}			
		}
		
		if($('#country').val() == 'MX')
		{			
			$('#city').val(response[0].admin_name_3);
		}
		else
		{
			$('#city').val(response[0].place_name);
			$('#addressDistrict input').val(response[0].admin_name_2);
		}		
	}
	
	getAddress(addressToFill)
	{
		addressToFill.pais = this.country;
		addressToFill.direccion = this.addressLine1;
		addressToFill.address2 = this.addressLine2;
		addressToFill.distrito = this.district;
		addressToFill.poblacion = this.city;
		addressToFill.cp = this.zipCode;
		addressToFill.provincia = this.state;
		addressToFill.stateCode = this.stateCode;
		addressToFill.telefono = this.phone;
		addressToFill.phoneCountryCode = this.phoneCountryCode;
	}
	
	getAddressToAddressClass(addressToFill)
	{
		addressToFill.addressLine = this.addressLine1;
		addressToFill.addressLine2 = this.addressLine2;
		addressToFill.city = this.city;
		addressToFill.countryState = this.state;
		addressToFill.stateCode = this.stateCode;
		addressToFill.zipCode = this.zipCode;
		addressToFill.country = this.country;
		addressToFill.district = this.district;
		addressToFill.telephone = this.phone;
	}
	
	loadAddress(address)
	{
		this.country = address.pais;
		this.state = address.provincia;
		this.stateCode = address.stateCode;
		this.zipCode = address.cp;
		this.city = address.poblacion;
		this.district = address.distrito;
		this.addressLine1 = address.direccion;
		this.addressLine2 = address.address2;
		this.phone = address.telefono;
		this.phoneCountryCode = address.phoneCountryCode;
		
		$("textarea[id=" + this.divId + "_input]").val(this.buildAddressText(false));
	}
	
	loadAddressFromAddressClass(address)
	{
		this.addressLine1 = address.addressLine;
		this.addressLine2 = address.addressLine2;
		this.city = address.city;
		this.state = address.countryState;
		this.stateCode = address.stateCode;
		this.zipCode = address.zipCode;
		this.country = address.country;
		this.district = address.district;
		this.phone = address.telephone;
		
		$("textarea[id=" + this.divId + "_input]").val(this.buildAddressText(false));
	}
}

window.selectCountry = null;

window.createAddress = function (divId)
{
	return new AddressEditor(divId);
}

let addressForms = [];
let suggestedAddresses = [];
let suggestedCities = [];
let countryChanged = null;
let stateChanged = null;
let lastInputCode = null;
let selectedAddressPosition = 0;
let validationInitialized = false;
window.setToNoValidate = false;
window.stateCodeSelectedNotSaved = null;

let geolocationUrl = null;

window.openSelectedAddressModal = function(divId)
{
	if($("#vAddressEditor").css("height") != '0px')
	{
		return;
	}
		
	for (let i in addressForms)
	{
		if (addressForms[i].divId == divId)
		{
			currentAddressEditor = addressForms[i];
			addressForms[i].openSelectedAddressModal();
			break;
		}
	}
}
